import React, { FC } from 'react'
import {
  ProgressBarBackdrop,
  ProgressBarContainer,
  ProgressBarFiller,
  ProgressBarLabel,
  ProgressBarScore
} from './styled'

type Props = {
  bgColor: any
  percentCompleted: number
  label?: string
  score?: number
}

const ProgressBar: FC<Props> = ({ bgColor, percentCompleted, label, score }) => (
  <ProgressBarContainer>
    <ProgressBarLabel>
      {label}
    </ProgressBarLabel>
    <ProgressBarBackdrop>
      <ProgressBarFiller bgColor={bgColor} percentCompleted={percentCompleted} />
    </ProgressBarBackdrop>
    <ProgressBarScore>
      {score}
    </ProgressBarScore>
  </ProgressBarContainer>
)

export default ProgressBar